


















import { defineComponent, computed } from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';

import useAuth from '@/useAuth';

// import CommonDropzoneWithStorageLimit from '@/components/CommonDropzoneWithStorageLimit.vue';

const CommonDropzoneWithAvatarUpload = defineComponent({
  // components: {
  //   CommonDropzoneWithStorageLimit,
  // },
  props: {
    avatarPath: {
      default: null,
    },
    userId: {
      default: null,
    },
  },
  setup(props, context) {
    const { hasPermission } = useAuth();
    // const variables = computed(() => {
    //   if (props.userId !== null) return { userId: props.userId };
    //   return {};
    // });

    const mutation = useMutation(gql`
      mutation uploadAvatar($avatar: Upload $password: String) {
        editProfile(avatar: $avatar password: $password) {
          id
          avatarPath
        }
      }
    `, {
      context: {
        hasUpload: true,
      },
      refetchQueries: ['getMyInfo'],
    });

    mutation.onDone((result) => {
      context.emit('done', result?.data.uploadAvatar);
    });

    // ====== CLEAR AVATAR ======
    const clearAvatar = useMutation(gql`
      mutation clearAvatar {
        clearAvatar {
          id
        }
      }
    `, {
      refetchQueries: ['getMyInfo'],
    });

    clearAvatar.onDone((result) => {
      context.emit('clearAvatarDone');
    });

    return {
      hasPermission,
      mutation,
      // variables,
      clearAvatar,
    };
  },
});

export default CommonDropzoneWithAvatarUpload;
